import { getApiInstance } from "../../AppService";
import { DELETE_BULK_INVENTORY_DRAFT_ROWS, GET_BULK_INVENTORY_DRAFT_PRODS, UPDATE_BULK_INVENTORY_DRAFT_PRODS, UPLOAD_BULK_INVENTORY_PRODUCTS } from "../../constant";

export const getAllBulkInventoryProductsApi = async (data) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId: data?.businessId,
      },
    });
    
    const response = await instance.get(GET_BULK_INVENTORY_DRAFT_PRODS, {
      params: {
        businessId: data?.businessId,
        status: "DRAFT",
      },
    });
    console.log("getAllBulkInventoryProductsApi", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const deleteBulkInventoryProductsApi = async (data) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId: data?.businessId,
      },
    });

    const response = await instance.post(DELETE_BULK_INVENTORY_DRAFT_ROWS, data?.deleteIds);
    console.log("getAllBulkInventoryProductsApi", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

// upload inventory excel data
export const uploadBulkInventoryProductApi = async (data) => {
  try {
    const formData = new FormData();
    formData.append('file', data?.selectedFile);

    const instance = getApiInstance({
      header: {
        businessId: data?.businessId,
      },
    });
    const response = await instance.post(UPLOAD_BULK_INVENTORY_PRODUCTS, formData);
    console.log("uploadBulkInventoryProductApi", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

// update inventory data in draft table
export const updateBulkInventoryDraftApi = async (data) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId: data?.businessId,
      },
    });

    const response = await instance.post(UPDATE_BULK_INVENTORY_DRAFT_PRODS, data?.postData);
    console.log("updateBulkInventoryDraftApi", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};
